import { render, staticRenderFns } from "./Askmebet.vue?vue&type=template&id=fd01e956&scoped=true&"
import script from "./Askmebet.vue?vue&type=script&lang=js&"
export * from "./Askmebet.vue?vue&type=script&lang=js&"
import style0 from "./Askmebet.vue?vue&type=style&index=0&id=fd01e956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01e956",
  null
  
)

export default component.exports